import { Outlet, useLocation } from "react-router-dom";
import { NavBar } from "./NavBar";
import { Toaster } from "sonner";

export function Shell() {
  const loc = useLocation();
  const fullScreen =
    loc.pathname === "/playtest/board" ||
    loc.pathname.startsWith("/playtest/online/");

  if (fullScreen) {
    return (
      <div className="min-h-screen bg-[#13151a] text-[#e2e8f0]">
        <Outlet />
        <Toaster richColors theme="dark" position="top-right" />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#13151a] text-[#e2e8f0]">
      <NavBar />
      <main className="mx-auto w-full max-w-7xl px-4 py-6 sm:px-6 lg:px-8">
        <Outlet />
      </main>
      <Toaster richColors theme="dark" position="top-right" />
    </div>
  );
}
